import { UserProfile, PricingTable } from '@clerk/react';
import Sidebar from '../components/Sidebar';
import ApiKeysPanel from '../components/ApiKeysPanel';
import WebhooksPanel from '../components/WebhooksPanel';
import { IconCard, IconKey, IconWebhook } from '../components/icons';

export default function Profile() {
  return (
    <div className="flex h-screen bg-bg font-sans text-ink">
      <Sidebar active="profile" />
      <div className="flex flex-1 flex-col overflow-hidden">
        <div className="flex h-14 shrink-0 items-center gap-4 border-b border-border2 px-6">
          <div className="font-display text-base font-bold">Profile</div>
        </div>
        <div className="flex flex-1 items-start justify-center overflow-auto p-6">
          <UserProfile path="/profile" routing="path">
            <UserProfile.Page label="Billing" url="billing" labelIcon={<IconCard />}>
              <PricingTable for="user" />
            </UserProfile.Page>
            <UserProfile.Page label="API Keys" url="api-keys" labelIcon={<IconKey />}>
              <ApiKeysPanel />
            </UserProfile.Page>
            <UserProfile.Page label="Webhooks" url="webhooks" labelIcon={<IconWebhook />}>
              <WebhooksPanel />
            </UserProfile.Page>
          </UserProfile>
        </div>
      </div>
    </div>
  );
}
